import styled from "styled-components";

const FieldError = styled.div.attrs(() => ({
  className: "px-3 mb-2 text-sm font-semibold text-red-800",
}))``;

export default FieldError;
